import { EUROPE } from 'enums/regions';
import * as Yup from 'yup';

export default (intl) => {
  const country = window.globalData.country;
  const isEuropeCountry = EUROPE.includes(country);

  if (isEuropeCountry) {
    return Yup.object().shape({
      project: Yup.object().shape({
        name: Yup.string().required(
          intl.formatMessage({ id: 'Debe ingresar un nombre' }),
        ),
        requirement: Yup.mixed()
          .required(intl.formatMessage({ id: 'Debe seleccionar un tipo' }))
          .typeError(
            intl.formatMessage({ id: 'Debe seleccionar un tipo válido' }),
          ),
        type: Yup.string()
          .required(intl.formatMessage({ id: 'Debe seleccionar un tipo' }))
          .typeError(
            intl.formatMessage({ id: 'Debe seleccionar un tipo válido' }),
          ),
        postalCode: Yup.string().required(
          intl.formatMessage({ id: 'Debe ingresar un código postal' }),
        ),
        state: Yup.string()
          .required(intl.formatMessage({ id: 'Debe seleccionar un país' }))
          .typeError(intl.formatMessage({ id: 'Debe seleccionar un país' })),
        needCase: Yup.boolean()
          .nullable()
          .required(intl.formatMessage({ id: 'Debe seleccionar una opción' }))
          .typeError(intl.formatMessage({ id: 'Debe seleccionar una opción' })),
        // TODO:
        // needCaseFileKey: Yup.string().when('needCase', {
        //   is: true,
        //   then: (schema) =>
        //     schema.required(
        //       intl.formatMessage({
        //         id: 'Debe subir el archivo del caso de estudio',
        //       }),
        //     ),
        //   otherwise: (schema) => schema,
        // }),
      }),
    });
  } else {
    return Yup.object().shape({
      project: Yup.object().shape({
        name: Yup.string().required(
          intl.formatMessage({ id: 'Debe ingresar un nombre' }),
        ),
        requirement: Yup.mixed()
          .required(intl.formatMessage({ id: 'Debe seleccionar un tipo' }))
          .typeError(
            intl.formatMessage({ id: 'Debe seleccionar un tipo válido' }),
          ),
        type: Yup.string()
          .required(intl.formatMessage({ id: 'Debe seleccionar un tipo' }))
          .typeError(
            intl.formatMessage({ id: 'Debe seleccionar un tipo válido' }),
          ),
        postalCode: Yup.string().required(
          intl.formatMessage({ id: 'Debe ingresar un código postal' }),
        ),
        state: Yup.string()
          .required(intl.formatMessage({ id: 'Debe seleccionar un país' }))
          .typeError(intl.formatMessage({ id: 'Debe seleccionar un país' })),
      }),
    });
  }
};
